import { render, staticRenderFns } from "./APPurPlanDatas.vue?vue&type=template&id=0e4a8a2b&scoped=true&"
import script from "./APPurPlanDatas.vue?vue&type=script&lang=js&"
export * from "./APPurPlanDatas.vue?vue&type=script&lang=js&"
import style0 from "./APPurPlanDatas.vue?vue&type=style&index=0&id=0e4a8a2b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4a8a2b",
  null
  
)

component.options.__file = "APPurPlanDatas.vue"
export default component.exports